import {
  FETCH_INVOICE_PREFIXES_ATTEMPT,
  FETCH_INVOICE_PREFIXES_SUCCESS,
  FETCH_INVOICE_PREFIXES_ERROR,
  FETCH_INVOICE_PREFIX_ATTEMPT,
  FETCH_INVOICE_PREFIX_SUCCESS,
  FETCH_INVOICE_PREFIX_ERROR,
  CREATE_INVOICE_PREFIX_ATTEMPT,
  CREATE_INVOICE_PREFIX_SUCCESS,
  CREATE_INVOICE_PREFIX_ERROR,
  CREATE_INVOICE_PREFIX_RESET_STATE,
  UPDATE_INVOICE_PREFIX_ATTEMPT,
  UPDATE_INVOICE_PREFIX_SUCCESS,
  UPDATE_INVOICE_PREFIX_ERROR,
  UPDATE_INVOICE_PREFIX_RESET_STATE,
  DELETE_INVOICE_PREFIX_ATTEMPT,
  DELETE_INVOICE_PREFIX_SUCCESS,
  DELETE_INVOICE_PREFIX_ERROR,
  DELETE_INVOICE_PREFIX_RESET_STATE,
} from "../actionTypes/actionTypes";

const initialState = {
  prefixes: {
    data: {
      data: [],
      perPage: 20,
      page: 1,
      total: 0,
    },
    attempt: false,
    success: false,
    error: null,
  },
  singlePrefix: {
    data: null,
    attempt: false,
    success: false,
    error: null,
  },
  createPrefix: {
    attempt: false,
    success: false,
    error: null,
    data: null,
  },
  updatePrefix: {
    attempt: false,
    success: false,
    error: null,
    data: null,
  },
  deletePrefix: {
    attempt: false,
    success: false,
    error: null,
  },
};

const invoicePrefixesReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch prefixes list
    case FETCH_INVOICE_PREFIXES_ATTEMPT:
      return {
        ...state,
        prefixes: {
          ...state.prefixes,
          attempt: true,
          success: false,
          error: null,
        },
      };
    case FETCH_INVOICE_PREFIXES_SUCCESS:
      return {
        ...state,
        prefixes: {
          data: action.payload,
          attempt: false,
          success: true,
          error: null,
        },
      };
    case FETCH_INVOICE_PREFIXES_ERROR:
      return {
        ...state,
        prefixes: {
          ...state.prefixes,
          attempt: false,
          success: false,
          error: action.payload,
        },
      };

    // Fetch single prefix
    case FETCH_INVOICE_PREFIX_ATTEMPT:
      return {
        ...state,
        singlePrefix: {
          ...state.singlePrefix,
          attempt: true,
          success: false,
          error: null,
        },
      };
    case FETCH_INVOICE_PREFIX_SUCCESS:
      return {
        ...state,
        singlePrefix: {
          data: action.payload,
          attempt: false,
          success: true,
          error: null,
        },
      };
    case FETCH_INVOICE_PREFIX_ERROR:
      return {
        ...state,
        singlePrefix: {
          ...state.singlePrefix,
          attempt: false,
          success: false,
          error: action.payload,
        },
      };

    // Create prefix
    case CREATE_INVOICE_PREFIX_ATTEMPT:
      return {
        ...state,
        createPrefix: {
          attempt: true,
          success: false,
          error: null,
          data: null,
        },
      };
    case CREATE_INVOICE_PREFIX_SUCCESS:
      return {
        ...state,
        createPrefix: {
          attempt: false,
          success: true,
          error: null,
          data: action.payload,
        },
        prefixes: {
          ...state.prefixes,
          data: {
            ...state.prefixes.data,
            data: [...state.prefixes.data.data, action.payload],
            total: state.prefixes.data.total + 1,
          },
        },
      };
    case CREATE_INVOICE_PREFIX_ERROR:
      return {
        ...state,
        createPrefix: {
          attempt: false,
          success: false,
          error: action.payload,
          data: null,
        },
      };
    case CREATE_INVOICE_PREFIX_RESET_STATE:
      return {
        ...state,
        createPrefix: {
          attempt: false,
          success: false,
          error: null,
          data: null,
        },
      };

    // Update prefix
    case UPDATE_INVOICE_PREFIX_ATTEMPT:
      return {
        ...state,
        updatePrefix: {
          attempt: true,
          success: false,
          error: null,
          data: null,
        },
      };
    case UPDATE_INVOICE_PREFIX_SUCCESS:
      return {
        ...state,
        updatePrefix: {
          attempt: false,
          success: true,
          error: null,
          data: action.payload,
        },
        prefixes: {
          ...state.prefixes,
          data: {
            ...state.prefixes.data,
            data: state.prefixes.data.data.map((prefix) =>
              prefix.id === action.payload.id ? action.payload : prefix
            ),
          },
        },
        singlePrefix: {
          ...state.singlePrefix,
          data: action.payload,
        },
      };
    case UPDATE_INVOICE_PREFIX_ERROR:
      return {
        ...state,
        updatePrefix: {
          attempt: false,
          success: false,
          error: action.payload,
          data: null,
        },
      };
    case UPDATE_INVOICE_PREFIX_RESET_STATE:
      return {
        ...state,
        updatePrefix: {
          attempt: false,
          success: false,
          error: null,
          data: null,
        },
      };

    // Delete prefix
    case DELETE_INVOICE_PREFIX_ATTEMPT:
      return {
        ...state,
        deletePrefix: {
          attempt: true,
          success: false,
          error: null,
        },
      };
    case DELETE_INVOICE_PREFIX_SUCCESS:
      return {
        ...state,
        deletePrefix: {
          attempt: false,
          success: true,
          error: null,
        },
        prefixes: {
          ...state.prefixes,
          data: {
            ...state.prefixes.data,
            data: state.prefixes.data.data.filter((prefix) => prefix.id !== action.payload),
            total: state.prefixes.data.total - 1,
          },
        },
      };
    case DELETE_INVOICE_PREFIX_ERROR:
      return {
        ...state,
        deletePrefix: {
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case DELETE_INVOICE_PREFIX_RESET_STATE:
      return {
        ...state,
        deletePrefix: {
          attempt: false,
          success: false,
          error: null,
        },
      };

    default:
      return state;
  }
};

export default invoicePrefixesReducer;

